import React from "react";
import PropTypes from "prop-types";
import { constants } from "../../styles";
import { Title } from "./style";

export var ModalTitle = function ModalTitle(_ref) {
  var status = _ref.status,
      children = _ref.children;
  return React.createElement(
    Title,
    { element: "h2", size: "sm", status: status },
    children
  );
};

var _constants$colors = constants.colors,
    PRIMARY = _constants$colors.PRIMARY,
    SUCCESS = _constants$colors.SUCCESS,
    WARNING = _constants$colors.WARNING,
    DANGER = _constants$colors.DANGER;

ModalTitle.propTypes = {
  status: PropTypes.oneOf([PRIMARY, SUCCESS, WARNING, DANGER]),
  children: PropTypes.node.isRequired
};
ModalTitle.defaultProps = {
  status: PRIMARY
};